import http from '../require'
export const userRoles = data => http.get('/v1/health/web/rbac/user_roles', data)
export const userDetail = data => http.get('/v1/health/uc/user/detail', data)
export const userUpdate = data => http.put('/v1/health/uc/user/update', data)
export const userInfo = data => http.get('/v1/health/web/user/user_info', data)
export const schoolInfo = data => http.get('/v1/health/web/user/school_info', data)
export const studentHealth = data => http.get('/v1/health/web/student_health/detail', data)
export const studentSurvey = data => http.get('/v1/health/web/student_health/survey', data)
export const schoolHealth = data => http.get('/v1/health/web/school_health/detail', data)
export const zoneHealth = data => http.get('/v1/health/web/zone_health/detail', data)
export const zoneHealthList = data => http.post('/v1/health/web/zone_health/zone_page', data)
export const schoolHealthList = data => http.post('/v1/health/web/school_health/school_page', data)
export const studentHealthList = data => http.post('/v1/health/web/student/page', data)
